/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../angularApp/app/unauthorized/unauthorized.component';
const styles_UnauthorizedComponent:any[] = ([] as any[]);
export const RenderType_UnauthorizedComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_UnauthorizedComponent,data:{}});
export function View_UnauthorizedComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),['401: You have no rights to access this. Please Login']))],
      (null as any),(null as any));
}
export function View_UnauthorizedComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'unauthorized',
      ([] as any[]),(null as any),(null as any),(null as any),View_UnauthorizedComponent_0,
      RenderType_UnauthorizedComponent)),i0.ɵdid(114688,(null as any),0,i1.UnauthorizedComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const UnauthorizedComponentNgFactory:i0.ComponentFactory<i1.UnauthorizedComponent> = i0.ɵccf('unauthorized',
    i1.UnauthorizedComponent,View_UnauthorizedComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovQml0YnVja2V0X1JlcG9zL3JhZGlvbmV0X21hbmFnZW1lbnRfY2xpZW50L1JhZGlvTmV0TWFuYWdlbWVudENsaWVudC9hbmd1bGFyQXBwL2FwcC91bmF1dGhvcml6ZWQvdW5hdXRob3JpemVkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9CaXRidWNrZXRfUmVwb3MvcmFkaW9uZXRfbWFuYWdlbWVudF9jbGllbnQvUmFkaW9OZXRNYW5hZ2VtZW50Q2xpZW50L2FuZ3VsYXJBcHAvYXBwL3VuYXV0aG9yaXplZC91bmF1dGhvcml6ZWQuY29tcG9uZW50LnRzIiwibmc6Ly8vQzovQml0YnVja2V0X1JlcG9zL3JhZGlvbmV0X21hbmFnZW1lbnRfY2xpZW50L1JhZGlvTmV0TWFuYWdlbWVudENsaWVudC9hbmd1bGFyQXBwL2FwcC91bmF1dGhvcml6ZWQvdW5hdXRob3JpemVkLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovQml0YnVja2V0X1JlcG9zL3JhZGlvbmV0X21hbmFnZW1lbnRfY2xpZW50L1JhZGlvTmV0TWFuYWdlbWVudENsaWVudC9hbmd1bGFyQXBwL2FwcC91bmF1dGhvcml6ZWQvdW5hdXRob3JpemVkLmNvbXBvbmVudC50cy5VbmF1dGhvcml6ZWRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2PjQwMTogWW91IGhhdmUgbm8gcmlnaHRzIHRvIGFjY2VzcyB0aGlzLiBQbGVhc2UgTG9naW48L2Rpdj4iLCI8dW5hdXRob3JpemVkPjwvdW5hdXRob3JpemVkPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQUs7YUFBQTs7OztvQkNBTDtNQUFBO3NDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./aot/angularApp/app/unauthorized/unauthorized.component.ngfactory.ts